import { useEffect, useState } from "react";
import { CATEGORY_GROUPS } from "@/data/catalog";
import CategoryCard from "@/components/CategoryCard";
import { fetchProducts } from "@/lib/api";

export default function CategorySection() {
  const [counts, setCounts] = useState({});
  useEffect(() => {
    fetchProducts()
      .then((list) => {
        const m = {};
        list.forEach((p) => (p.categories || [p.categorySlug]).forEach((c) => (m[c] = (m[c] || 0) + 1)));
        setCounts(m);
      })
      .catch(() => {});
  }, []);

  return (
    <section id="shop-by-category" className="scroll-mt-28 border-y border-slate-200 bg-slate-50">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-20 lg:px-8">
        <div className="mb-10 max-w-2xl">
          <span className="font-mono text-xs font-bold uppercase tracking-[0.2em] text-sky-700">Equipment Departments</span>
          <h2 className="mt-2 font-heading text-3xl font-black tracking-tight text-slate-900 sm:text-4xl">Shop by Category</h2>
          <p className="mt-3 text-sm leading-relaxed text-slate-600">
            From condensers and packaged units to ductless mini-splits and VRF systems — every department links straight
            to a filtered catalog with exact model numbers.
          </p>
        </div>

        <div className="space-y-10">
          {CATEGORY_GROUPS.map((group) => {
            const cats = group.categories.filter((c) => !c.hidden);
            return (
              <div key={group.label}>
                <div className="mb-4 flex items-center gap-3">
                  <h3 className="font-heading text-sm font-bold uppercase tracking-[0.15em] text-slate-500">{group.label}</h3>
                  <span className="h-px flex-1 bg-slate-200" />
                </div>
                <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4 xl:grid-cols-5">
                  {cats.map((c) => <CategoryCard key={c.slug} category={c} count={counts[c.slug] ?? null} />)}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
